import { Svg } from 'client/widget-components/basicComponents';
import React from 'react';

interface UploadIconProps extends React.ComponentProps<typeof Svg> {
    size?: number;
}

const UploadIcon = ({ size = 16, ...restProps }: UploadIconProps) => {
    return (
        <Svg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            <path
                d="M1.5 12.8333V11.1667C1.5 10.7985 1.79847 10.5 2.16667 10.5C2.53485 10.5 2.83333 10.7985 2.83333 11.1667V12.8333C2.83333 13.0174 2.98257 13.1667 3.16667 13.1667H12.8333C13.0174 13.1667 13.1666 13.0174 13.1666 12.8333V11.1667C13.1666 10.7985 13.4652 10.5 13.8333 10.5C14.2015 10.5 14.5 10.7985 14.5 11.1667V12.8333C14.5 13.6962 13.8442 14.4061 13.0039 14.4915L12.8333 14.5H3.16667C2.24619 14.5 1.5 13.7538 1.5 12.8333Z"
                fill="currentColor"
            />
            <path
                d="M7.33318 10.5C7.33318 10.8682 7.63165 11.1666 7.99985 11.1666C8.36805 11.1666 8.66652 10.8682 8.66652 10.5V3.77599L10.5285 5.63797C10.7889 5.89832 11.2109 5.89832 11.4713 5.63797C11.7316 5.37762 11.7316 4.95561 11.4713 4.69526L8.47125 1.69526C8.21085 1.43491 7.78885 1.43491 7.52852 1.69526L4.52851 4.69526C4.26817 4.95561 4.26817 5.37762 4.52851 5.63797C4.77259 5.88205 5.15859 5.89711 5.42044 5.68355L5.47122 5.63797L7.33318 3.77599V10.5Z"
                fill="currentColor"
            />
        </Svg>
    );
};

export default UploadIcon;

